module.exports = __webpack_public_path__ + "media/components/assets/img/ios-bookmark-7304066ae402b2029c8f9f354f400c17.png";